var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 50,
    viewBox: "0 0 116 109",
    style: {
      fontSize: "1.8rem"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 1.61,
    y1: 54.558,
    x2: 113.455,
    y2: 54.558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f012"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 63v-.7c1.3-21.3 6.6-38.4 21-51.7C31 2.7 51.7-2.1 59.3 7.4c3.5 4.4 6 10.1 7.5 15.6 3.9 13.8 9.7 18 23.2 19.4 14.4 1.5 22.1 10.6 23.3 24.4 1.4 16.3-5.1 28.3-18.8 36.7-8.8 5.4-22.9 4.4-30.6-2.7-3-2.8-5.8-5.7-8.6-8.7-4.3-4.6-10.5-6.1-16.5-3.8-3.4 1.3-6.8 2.5-10.2 3.7C18.4 95.6 8 88.6 4.4 76.8 2.8 71.7 1.7 67.5 1.6 63z",
    fill: "url(#A)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8 31.9c4.2 6.9 6.7 15.1 6.7 23.8 0 25.2-20.5 45.7-45.7 45.7S12.1 81 12.1 55.7 32.5 10 57.8 10c8.8 0 17 2.5 24 6.8",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3 31.3H48.5c-1.2 0-2.1.9-2.1 2.1v21.1c0 1.2.9 2.1 2.1 2.1h14.8C70.3 56.7 76 51 76 44s-5.7-12.7-12.7-12.7zm0 21.1H50.7V35.5h12.7c4.7 0 8.5 3.8 8.5 8.5s-3.9 8.4-8.6 8.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3 52.4H48.5c-1.2 0-2.1.9-2.1 2.1v21.1c0 1.2.9 2.1 2.1 2.1h14.8C70.3 77.7 76 72 76 65c0-6.9-5.7-12.6-12.7-12.6zm0 21.2H50.7V56.7h12.7c4.7 0 8.5 3.8 8.5 8.5a8.63 8.63 0 0 1-8.6 8.4zM48.5 31.3H40c-1.2 0-2.1.9-2.1 2.1s.9 2.1 2.1 2.1h8.5c1.2 0 2.1-.9 2.1-2.1.1-1.2-.9-2.1-2.1-2.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 22.8c-1.2 0-2.1.9-2.1 2.1v8.5c0 1.2.9 2.1 2.1 2.1s2.1-.9 2.1-2.1V25c.1-1.2-.9-2.2-2.1-2.2zm12.7 0c-1.2 0-2.1.9-2.1 2.1v8.5c0 1.2.9 2.1 2.1 2.1s2.1-.9 2.1-2.1V25c0-1.2-.9-2.2-2.1-2.2zM48.5 73.6c-1.2 0-2.1.9-2.1 2.1v8.5c0 1.2.9 2.1 2.1 2.1s2.1-.9 2.1-2.1v-8.5c.1-1.2-.9-2.1-2.1-2.1zm12.7 0c-1.2 0-2.1.9-2.1 2.1v8.5c0 1.2.9 2.1 2.1 2.1s2.1-.9 2.1-2.1v-8.5c0-1.2-.9-2.1-2.1-2.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 73.6H40c-1.2 0-2.1.9-2.1 2.1s.9 2.1 2.1 2.1h8.5c1.2 0 2.1-.9 2.1-2.1.1-1.2-.9-2.1-2.1-2.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e8a2e0f58926583f85cd06e5fa8538b7.svg";
export { ForwardRef as ReactComponent };